function currency(n) {
  let coin = '€';

  if (n === '' || n === null || n === 0) {
    return '0 ' + coin;
  }

  n = parseFloat(n);
  const isNegative = n < 0;

  let currencyValue = 'EUR';
  n = Math.abs(n).toLocaleString('en-EN', {
    style: 'currency',
    currency: currencyValue
  });

  // Ajustes para iOS e formato europeu
  n = n.replace(/\./g, '!')
       .replace(/,/g, '.')
       .replace(/!/g, ',')
       .split(',00')[0]
       .split('€')[1]
       .trim();

  return (isNegative ? '-' : '') + n + ' ' + coin;
}

export default currency;
